import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import { SlCancelIcon, SlCancelIconProps } from 'src/components/BeaconV2Components/SlIcons/SlCancelIcon';

interface SlCancelButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  slCancelIconProps?: SlCancelIconProps;
}

/**
 * Reusable cancel button component using the SlCancelIcon
 */
export const SlCancelButton = ({ slCancelIconProps, onClick, ...rest }: SlCancelButtonProps) => {
  const theme = useStacklineTheme();
  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ display: 'flex', border: 'none', background: 'none', padding: 0 }}
      onClick={onClick}
      {...rest}
    >
      <SlCancelIcon color={hovered ? theme.colors.primary : theme.colors.secondary} size="16" {...slCancelIconProps} />
    </button>
  );
};
